var _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgAccess = function SvgAccess(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ae88d802-9845-4455-a845-03f65b686abd",
    "data-name": "Layer 8",
    viewBox: "0 0 83 105.95",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "e25952a2-8a8c-4237-9b72-0d21e0c9b143",
    "data-name": "Door"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a8b0c81b-c434-4936-a06a-e78a71fb6dcf",
    "data-name": "Door Access"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ef5363d5-34c4-4ff7-b08d-5638de553bb1",
    d: "M120.29,1.44H55.83A4.53,4.53,0,0,0,51.32,6V30.84h4.49V5.93h64.5v97H55.81V77H51.32v25.92a4.53,4.53,0,0,0,4.51,4.52h64.46a4.52,4.52,0,0,0,4.51-4.52V6A4.52,4.52,0,0,0,120.29,1.44Z",
    transform: "translate(-41.8 -1.44)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ef5363d5-34c4-4ff7-b08d-5638de553bb1",
    d: "M70.28,70.85A2.21,2.21,0,0,0,73.41,74L92,55.34a2.24,2.24,0,0,0,0-2.92l-.12-.11L73.41,33.82a2.21,2.21,0,0,0-3.13,3.12L85,51.69H44a2.21,2.21,0,0,0,0,4.42H85Z",
    transform: "translate(-41.8 -1.44)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "ef5363d5-34c4-4ff7-b08d-5638de553bb1",
    cx: 67,
    cy: 52.21,
    r: 6
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAccess, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/access.8fa7613d.svg";
export { ForwardRef as ReactComponent };